module.exports = __webpack_public_path__ + "img/bg1.8dd4e931.png";